import HTMLTemplate from './template.html'
import './styles.scss'
import ClientPortalAPIService from '../../services/api/ClientPortal/ApiService'
import moment from 'moment'
import DashboardGridBG from './../../resources/images/dashboard/cp-grid.png'
import DashboardBG from './../../resources/images/dashboard/dashboard-bg.png'
import { SideNavigation } from '../SideNavigation/SideNavigation'

export const InsightsAndReports = (() => {
    const vueComponent = {
        data() {
            return {
                showInsightsAndReports: false,
                isLoadingInsightsAndReports: true,
                serverErrorInsightsAndReports: null,
                insightsAndReports: [],
                filterByType: 'All', // Reports, Forecasts
                sortBy: 'Newest', // Oldest
                dashboardGridBG: DashboardGridBG,
                dashboardBG: DashboardBG,
            }
        },
        methods: {
            initialize() {
                this.fetchInsightsAndReports()
            },
            fetchInsightsAndReports() {
                this.isLoadingInsightsAndReports = true
                this.serverErrorInsightsAndReports = null
                ClientPortalAPIService.getInternationalSosInsightReports()
                    .then(insightsAndReports => {
                        if (insightsAndReports.Alerts.length > 0) {
                            // If MediaLinkFullyQualified is empty, remove the alert from the list
                            const filteredInsightsAndReports = insightsAndReports.Alerts.filter(alert => alert.MediaLinkFullyQualified !== null && alert.MediaLinkFullyQualified !== '')
                            const updatedInsightsAndReports = filteredInsightsAndReports.map(alert => {
                                return {
                                    ...alert,
                                    displayCreationDate: moment.utc(alert.CreatedDate).format('DD/MM/YYYY'),
                                    displayName: this.formatUrl(alert.MediaLink)
                                }
                            })

                            this.insightsAndReports = updatedInsightsAndReports
                            this.sortInsightsAndReports()
                        }
                    })
                    .catch((error) => {
                        console.error('Error fetching Insights and Reports', error)
                        window.alert('There was an error fetching the Insights and Reports. Please try again later.')
                    })
                    .finally(() => {
                        this.isLoadingInsightsAndReports = false
                    })
            },
            sortInsightsAndReports() {
                this.insightsAndReports = this.insightsAndReports.sort((a, b) => {
                    if (this.sortBy === 'Newest') {
                        return moment.utc(b.CreatedDate).diff(moment.utc(a.CreatedDate))
                    } else {
                        return moment.utc(a.CreatedDate).diff(moment.utc(b.CreatedDate))
                    }
                })
            },
            formatUrl(url) {
                // Extract the filename from the URL
                const filename = url.split('/').pop().split('?')[0]
                
                // Remove the .pdf extension
                const nameWithoutExtension = filename.replace('.pdf', '')
                
                // Replace hyphens with spaces
                const nameWithSpaces = nameWithoutExtension.replace(/-/g, ' ')
                
                // Capitalize the first letter of each word
                const formattedName = nameWithSpaces.replace(/\b\w/g, char => char.toUpperCase())
                
                return formattedName
            },
            hide() {
                this.showInsightsAndReports = false
                SideNavigation.$data.activeModule = ''
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-insights-and-reports')
    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).mount(DOMElement)
    }
})()
